import React, { Component } from 'react';
import { Circle } from 'rc-progress';
import iconCheck from '../../../../../../../images/iconCheck.png'
import iconOver from '../../../../../../../images/iconOver.png'

import '../../../.././../../../css/tracker.sass'

class MacroAdjustmentGraph extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  getProteinTextColor = (remainingProtein, targetProtein) => { 
    return '#060a27'
  }

  getProteinCircleColor = (remainingProtein, targetProtein) => {
    const proteinSlope = Math.round((1/30 * targetProtein) + (6.6666666667))
    if(targetProtein <= 100) {
      if (remainingProtein < -10)
        return '#ed28a5'
      else if (remainingProtein >= -10 && remainingProtein <= 10)
        return '#00ee46'
      else
        return '#31bfff'
    }

    else if(targetProtein > 100 && targetProtein < 250) {
      if (remainingProtein < -proteinSlope)
        return '#ed28a5'
      else if (remainingProtein >= -proteinSlope && remainingProtein <= proteinSlope)
        return '#00ee46'
      else
        return '#31bfff'
    }

    else {
      if (remainingProtein < -15)
        return '#ed28a5'
      else if (remainingProtein >= -15 && remainingProtein <= 15)
        return '#00ee46'
      else
        return '#31bfff'
    }
  }

  getCarbsTextColor = (remainingCarbs, targetCarbs) => {
    return '#060a27'
  }

  getCarbsCircleColor = (remainingCarbs, targetCarbs) => {
    const carbsSlope = Math.round((11/450 * targetCarbs) + (3.7777777778))
    if(targetCarbs <= 50) {
      if (remainingCarbs < -5)
        return '#ed28a5'
      else if (remainingCarbs >= -5 && remainingCarbs <= 5)
        return '#00ee46'
      else
        return '#31bfff'
    }

    else if(targetCarbs > 50 && targetCarbs < 500) {
      if (remainingCarbs < -carbsSlope)
        return '#ed28a5'
      else if (remainingCarbs >= -carbsSlope && remainingCarbs <= carbsSlope)
        return '#00ee46'
      else
        return '#31bfff'
    }

    else {
      if (remainingCarbs < -16)
        return '#ed28a5'
      else if (remainingCarbs >= -16 && remainingCarbs <= 16)
        return '#00ee46'
      else
        return '#31bfff'
    }
  }

  getFatTextColor = (remainingFat, targetFat) => {
    return '#060a27'
  }

  getFatCircleColor = (remainingFat, targetFat) => {
    const fatSlope = Math.round((2/75 * targetFat) + (10/3))
    if(targetFat <= 25) {
      if (remainingFat < -4)
        return '#ed28a5'
      else if (remainingFat >= -4 && remainingFat <= 4)
        return '#00ee46'
      else
        return '#31bfff'
    }

    else if(targetFat > 25 && targetFat < 175) {
      if (remainingFat < -fatSlope)
        return '#ed28a5'
      else if (remainingFat >= -fatSlope && remainingFat <= fatSlope) {
        return '#00ee46'
      }
      else
        return '#31bfff'
    }

    else {
      if (remainingFat < -8)
        return '#ed28a5'
      else if (remainingFat >= -8 && remainingFat <= 8)
        return '#00ee46'
      else
        return '#31bfff'
    }
  }
  
  renderRangeText = (color) => {
    if(color === '#00ee46') {
      return (
        <p className="checkin-range-label"><img src={iconCheck} alt="check" /> IN RANGE</p>
      )
    } else {
      return (
        <p className="checkin-range-label"><img src={iconOver} alt="alert" /> OVER RANGE</p>
      )
    }
  }

  renderGraphs = () => {
    return (
      <React.Fragment>
        <div className="check-in-graph-container" style={{paddingTop: 0}}>
          <div>
            <div className="circle-container">
              <Circle
                percent={100}
                strokeWidth="5"
                strokeLinecap="round"
                strokeColor="#f2f6ff"
                trailWidth="5"
                trailColor="#f2f6ff"
              />
              <div className="tracker-graph-data">
                <div className="checkin-graph-macros">
                  <h6>Protein</h6>
                  <h4 style={{ color: this.getProteinTextColor() }}>{this.props.proteinValue}</h4>
                  <h6>GRAMS</h6>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="circle-container circle-center" >
              <Circle
                percent={100}
                strokeWidth="5"
                strokeLinecap="round"
                strokeColor="#f2f6ff"
                trailWidth="5"
                trailColor="#f2f6ff"
              />
              <div className="tracker-graph-data">
                <div className="checkin-graph-macros">
                  <h6>Carbs</h6>
                  <h4 style={{ color: this.getCarbsTextColor() }}>{this.props.carbsValue}</h4>
                  <h6>GRAMS</h6>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="circle-container">
              <Circle
                percent={100}
                strokeWidth="5"
                strokeLinecap="round"
                strokeColor="#f2f6ff"
                trailWidth="5"
                trailColor="#f2f6ff"
              />
              <div className="tracker-graph-data">
                <div className="checkin-graph-macros">
                  <h6>Fat</h6>
                  <h4 style={{ color: this.getFatTextColor() }}>{this.props.fatValue}</h4>
                  <h6>GRAMS</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  };

  render() {
    return <div>{this.renderGraphs()}</div>;
  }
}

export default MacroAdjustmentGraph;
